import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import LockPDFImageListScreen from "./LockPDFImageListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function LockPDFMin() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Lock PDF documents" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/lock_pdf", title: "PDF Locker" },
    data2: { link: "/lock_pdf", title: "Password Protect PDF Documents" },
    data3: { link: "/lock_pdf", title: "Encrypt PDF Documents" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Lock PDF files online instantly. Add password protection, secure sensitive documents, and protect PDFs easily with our fast PDF lock tool."
      ></meta>
      <meta
        name="keywords"
        content="lock pdf, lock pdf online, pdf lock, password protect pdf, secure pdf, encrypt pdf, protect pdf file, add password to pdf, pdf security, pdf protection tool, lock pdf free, secure pdf online, pdf encryption tool, protect pdf documents, pdf locker"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <LockPDFImageListScreen title={title}></LockPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Lock PDF is a secure and user-friendly PDF locker website designed to lock PDF files and protect sensitive documents completely offline, making it an ideal solution for users who value privacy and data security. Unlike online PDF locking tools that require uploading files to external servers, this offline PDF locker works directly on your device, ensuring that your PDF files never leave your system and remain fully confidential. With PDF Locker, users can easily lock PDF documents, password protect PDF files, apply strong PDF encryption, and prevent unauthorized access, editing, copying, or printing of important documents without needing an internet connection. The website offers fast performance, preserves original document quality, and features a simple, intuitive interface that allows anyone to lock PDF files in just a few clicks. This offline PDF protection tool is perfect for securing personal files, business documents, legal papers, financial records, academic materials, and confidential reports while maintaining complete control over data privacy. By eliminating cloud dependency and online risks, PDF Locker provides a reliable PDF security website for users seeking lock PDF solutions, offline PDF encryption, secure PDF documents, and password-protected PDF files with maximum safety, convenience, and trust." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Lock",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Lock PDF"
            why_use={[
              {
                title: "Complete Data Privacy",
                description:
                  "Our lock PDF offline tool ensures that your files never leave your device, providing maximum data privacy and security. Unlike online PDF locker websites, offline PDF locking tools do not upload documents to external servers, reducing the risk of data breaches and unauthorized access.",
              },
              {
                title: "Works Without Internet Connection",
                description:
                  "Our offline PDF locker works even without internet access, making it ideal for users in low-connectivity areas or those who prefer secure PDF protection without relying on cloud services. You can lock PDF files anytime, anywhere.",
              },
              {
                title: "Enhanced Security with Strong Encryption",
                description:
                  "Offline lock PDF tools use advanced PDF encryption to password protect PDF files, ensuring only authorized users can open, edit, copy, or print the document. This makes it a reliable solution for securing confidential PDF documents.",
              },

              {
                title: "Faster PDF Locking Process",
                description:
                  "Since files are processed locally, an offline PDF locking tool offers faster performance compared to online tools. You can instantly lock PDF documents without upload or download delays.",
              },
              {
                title: "No File Size Limits",
                description:
                  "Other online PDF lockers have file size restrictions, while offline PDF lock tools allow you to lock large PDF files easily. This makes them perfect for business reports, legal documents, and high-resolution PDFs.",
              },
              {
                title: "No Account or Registration Required",
                description:
                  "This offline PDF locker does not require sign-ups or personal information. You can lock PDF files without creating an account, ensuring a secure and hassle-free experience.",
              },
              {
                title: "Ideal for Sensitive and Confidential Documents",
                description:
                  "Lock PDF offline tools are perfect for securing legal files, financial statements, medical records, academic documents, and corporate data, providing trusted offline PDF protection.",
              },
              {
                title: "Prevents Unauthorized Editing and Printing",
                description:
                  "With a lock PDF tool, you can restrict editing, copying, and printing of PDF files, ensuring complete document control and protection from misuse.",
              },
              {
                title: "Cross-Platform Compatibility",
                description:
                  "Our offline PDF locker tools work across multiple operating systems and browsers, allowing users to securely lock PDF files on different devices without internet dependency.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1623109999}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default LockPDFMin;
